/* Fransk katalog for locale-closing-cash-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'clo.cash.quickComments': 'Commentaires rapides',
  'clo.cash.quickCountLabel': 'Compté par le directeur général',
  'clo.cash.quickCountText': 'L\'encaisse a été comptée physiquement au 31.12.{{year}} par le directeur général.',
  'clo.cash.quickSheetLabel': 'Fiche de comptage enregistrée',
  'clo.cash.quickSheetText': 'La fiche de comptage signée a été contrôlée et enregistrée dans le dossier des justificatifs.',
  'clo.cash.quickReportLabel': 'Contrôlé par rapport au rapport de caisse',
  'clo.cash.quickReportText': 'Le comptage a été contrôlé par rapport au rapport de caisse au 31.12.{{year}}.',
  'clo.cash.openPosting': 'Créer une écriture libre',
  'clo.cash.postingTitle': 'Corriger l\'encaisse',
  'clo.cash.postingDescription': 'Correction après comptage de caisse {{year}}',
  'clo.cash.postingLoadError': 'Impossible de charger l\'écriture libre.',
  'clo.cash.postingSaved': 'L\'écriture a été comptabilisée. Vérifiez à nouveau l\'écart.',
});
